<!--  -->
<template>
<div class='' style="position:relative;">
   <!-- 桌面端导航 -->
   <div class="nav desktop-nav">
        <div class="back">
          <img src="@/assets/back.png" title="返回首页" @click="goBlack()"/>
        </div>
         <div id="navList" :class="type" @mouseover="changeStatus(1)" @mouseleave="changeStatus(0)">
            <ul v-show="navStatus==0" style="display:block;transition:display 2s ease">
              <li class="selected">
                {{selectedTitle}}
              </li>
            </ul>
            <ul v-show="navStatus!=0">
              <li v-for="(item,index) in navList" :key="item" :class="type=='image'&&index==sindex?'selected':type!='image'?index==0?'one':'':'noSelected'" @click="selected(index)">{{item.split(",")[0]}}</li>
            </ul>
         </div>
      </div>
      <!-- 移动端导航 -->
      <div class="mobile-nav-bar">
        <div class="mobile-back" @click="goBlack()">
          <img src="@/assets/back.png" title="返回首页"/>
        </div>
        <div class="mobile-title">{{selectedTitle}}</div>
        <div class="mobile-menu-btn" @click="toggleMobileMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      
      <!-- 移动端菜单 -->
      <div class="mobile-menu-overlay" v-show="mobileMenuOpen" @click="toggleMobileMenu"></div>
      <transition name="slide-down">
        <div class="mobile-menu" v-show="mobileMenuOpen">
          <div class="mobile-menu-header">
            <img src="@/assets/pig.png" alt="logo"/>
            <span class="close-btn" @click="toggleMobileMenu">&times;</span>
          </div>
          <ul class="mobile-menu-list">
            <li 
              v-for="(item, index) in navList" 
              :key="index"
              :class="{ active: isCurrentNav(index) }"
              @click="selected(index)"
            >
              {{item.split(",")[0]}}
            </li>
          </ul>
        </div>
      </transition>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';


export default {
name:"Nav",
//import引入的组件需要注入到对象中才能使用
components: {},
 props:{
   navList:{
    type:Array,
   },
   ssindex:{
    type:Number,
   },
   type:{
    type:String,
    default:"normal"
   },
   changeClassify:{
    type:Function
   }
 },
data() {
//这里存放数据
return {
  sindex:0,
  selectedTitle:"",
  navStatus:0,
  t:"",
  mobileMenuOpen: false
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {
  ssindex(val){
    // this.sindex = val
    this.sindex = 0
    this.selectedTitle = this.navList[val]
    var item = this.navList[0]
    this.navList[0] = this.navList[val]
    this.navList[val] = item
  },

},
//方法集合
methods: {
  changeStatus(type){
    clearTimeout(this.t)
    if(type==0 && this.type=='image'){
       this.t = setTimeout(()=>{
        this.navStatus=type
      },1200)
    }else{
      this.navStatus=type
    }

    
  },
 goBlack(){
   this.$router.push('/')
 },
 selected(index){
  if(this.type=="image"){
    this.selectedTitle = this.navList[index]
    if(this.changeClassify!=undefined){
     this.changeClassify(this.navList[0])
    }
    var item = this.navList[0]
    this.navList[0] = this.navList[index]
    this.navList[index] = item
    this.sindex=0;
  }else{
    this.$router.push({path:this.navList[index].split(",")[1]})
  }
  this.mobileMenuOpen = false;
 },
 toggleMobileMenu(){
   this.mobileMenuOpen = !this.mobileMenuOpen;
   document.body.style.overflow = this.mobileMenuOpen ? 'hidden' : '';
 },
 isCurrentNav(index) {
   return index === 0;
 }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
  if(this.type!="image"){
  this.selectedTitle = this.navList[0].split(",")[0]
  }
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
/* 桌面端导航 */
.nav{
  // width:200px auto;
  /* min-width:200px; */
  left:6%;
  top:80px;
  position:fixed;
  display: flex;
  justify-content:flex-start;
  z-index:1000;
  
  @media screen and (max-width: 768px) {
    display: none;
  }
}

.desktop-nav {
  @media screen and (max-width: 768px) {
    display: none;
  }
}

#navList{
  // min-width:80%;

}
#navList ul{
  margin-top:0px;
  padding-left:0px;
  max-width:300px;
  overflow:hidden;
  transition:max-width 1.2s ease;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
#navList ul:hover{
  max-width:1200px;
}
#navList li{
  padding:8px 16px;
  text-align: center;
  height: auto;
  line-height: 1.4;
  font-size: 15px;
  border-radius:20px;
  list-style: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  
  @media screen and (max-width: 1919px) and (min-width: 1367px) {
    font-size: 14px;
    padding: 7px 14px;
  }
  
  @media screen and (max-width: 1366px) and (min-width: 1025px) {
    font-size: 13px;
    padding: 6px 12px;
  }
}
.normal li{
  border:1px solid black;/*no*/
}
.show li{
  background-color: rgba(255, 255, 255, 0.3);                                                                                                                            
  border: none;
}
.image li{
  display: inline-block;
  letter-spacing: 1px;
  font-size: 14px;
  padding: 5px 8px;
}
.imgae ul{
  width:100% auto;
}
.image{
  display:inline-block;
  border:1px solid black;/*no*/
  box-sizing:content-box;
  white-space: nowrap;
  border-radius:15px;
  height:32px;
}
.show li:not(:nth-child(1)){
  cursor:pointer;
}
.normal li:not(:nth-child(1)){
  cursor:pointer;
}
.show li:not(:nth-child(1)):hover{
  animation-name:snav;
  animation-duration: 0.2s;
  animation-direction: alternate;
  // animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}
.image:hover .selected{ //调整形象大片样式
  background-color: white;
  color:black;
}
.image .selected:hover{
  background-color: black;
  color:white;
}
.normal:hover .one{//调整公司简介样式
  background-color: white;
  color:black;
}
// .normal .one:hover{
//   background-color: black;
//   color:white;
// }
.normal li:hover{
  animation-name:snav;
  animation-duration: 0.2s;
  animation-direction: alternate;
  // animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

.show:hover .one{//调整公司简介样式中门店展示样式
  background-color: rgba(255, 255, 255, 0.3); 
  color:black;
}
.show .one:hover{
  background-color: black;
  color:white;
}
.show li:nth-child(1){
  background-color: black;
  color:white;
  opacity: 1;
}
.normal li:nth-child(1){
  background-color: black;
  color:white;
  opacity: 1;
}
.selected{//形象大片导航被选中
  background-color: black;
  color:white;
  opacity: 1;
}
.noSelected{//形象大片导航未被选中
  cursor:pointer;
  color:rgb(0, 0, 0);
  opacity: 1;
}
.noSelected:hover{
  animation-name:snav;
  animation-duration: 0.2s;
  animation-direction: alternate;
  // animation-iteration-count: infinite;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
}
.back{
  width:41px;
  text-align: center;
  padding-right:10px;
}
.back img{
  width:41px;
  height:41px;
  cursor: pointer;
}
.back img:hover{
  animation-name: sback;
  animation-fill-mode: forwards;
  animation-duration: 0.1s;
}

/* 移动端导航样式 */
.mobile-nav-bar {
  display: none !important;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  background-color: rgba(251, 251, 251, 0.98);
  z-index: 1001;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  box-sizing: border-box;
  
  @media screen and (max-width: 768px) {
    display: flex !important;
  }
}

.mobile-back {
  img {
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
}

.mobile-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  max-width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.4;
}

.mobile-menu-btn {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 18px;
  cursor: pointer;
  
  span {
    display: block;
    width: 100%;
    height: 2px;
    background-color: #333;
  }
}

.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1002;
}

.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 85%;
  max-width: 320px;
  height: 100%;
  background-color: #fff;
  z-index: 1003;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  
  .mobile-menu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    background-color: #f5f5f5;
    
    img {
      width: 100px;
      height: auto;
    }
    
    .close-btn {
      font-size: 28px;
      cursor: pointer;
      color: #666;
      line-height: 1;
      
      &:hover {
        color: #333;
      }
    }
  }
  
  .mobile-menu-list {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      padding: 18px 20px;
      font-size: 16px;
      border-bottom: 1px solid #eee;
      cursor: pointer;
      transition: background-color 0.3s;
      line-height: 1.4;
      
      &:hover, &.active {
        background-color: #f0f0f0;
        color: #000;
      }
      
      &.active {
        font-weight: bold;
        border-left: 3px solid #000;
      }
    }
  }
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.3s ease;
}

.slide-down-enter,
.slide-down-leave-to {
  transform: translateX(-100%);
}

@keyframes snav {
  to{
    // font-size: 26.5px;
    // padding:8px 8px 8px 8px;
    // font-weight: bold;
    // text-shadow: 7px 2px 2px rgb(150, 143, 143);
    background-color: black;
    color:white;
  }
}
@keyframes sback{
  to{
      width:42px;
      height:42px;
      // margin-top:-2px;
  }
}
</style>
